import {
  Button,
  CloseButton,
  FileDrop,
  Grid,
  Heading,
  IconModuleLine,
  Modal,
  Spinner,
  Text,
  View,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { ExternalService } from "../../services/ExternalService";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";

const UploadMeasuresModal = ({ id, uploadDialog, setUploadDialog }) => {
  const showNotification = useNotification();
  const [measureFiles, setMeasureFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await ExternalService.saveFiles(
        measureFiles,
        "qualitativeEvidence",
        id,
        "evidence.zip"
      );
      setUploadDialog(false);
      showNotification(t("notifications.assessmentResults.uploadSuccess"));
    } catch {
      showNotification(t("notifications.assessmentResults.uploadError"), ERROR);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      label={t("notifications.assessmentResults.uploadMeasureEvidence")}
      open={uploadDialog}
      onExited={() => setMeasureFiles([])}
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => setUploadDialog(false)}
          screenReaderLabel={t("global.close")}
        />
        <Heading as="h3">
          {t("notifications.assessmentResults.uploadMeasureEvidence")}
        </Heading>
      </Modal.Header>
      <Modal.Body>
        <FileDrop
          accept=".csv,.txt,.xls,.xlsx,.pdf,.doc,.docx,.jpg,.jpeg,.png,.zip"
          onDropAccepted={(files) => setMeasureFiles(files)}
          onDropRejected={() => {
            showNotification(t("notifications.invalidFileType"), ERROR);
          }}
          shouldAllowMultiple
          renderLabel={
            <View as="div" padding="xx-large large" background="primary">
              <IconModuleLine size="large" />
              <Heading>
                {t("notifications.assessmentResults.dragFiles")}
              </Heading>
              <Grid>
                <Grid.Row hAlign="center">
                  <Grid.Col>
                    <Text color="brand">{t("ilo.dragAndDropLabel")}</Text>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row hAlign="center">
                  <Grid.Col>
                    {measureFiles.map((file) => file.name).join(", ")}
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            </View>
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setUploadDialog(false)} margin="0 x-small 0 0">
          {t("global.close")}
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={measureFiles.length === 0 || submitting}
        >
          {submitting ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.submit")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadMeasuresModal;
